export const isValidUrl = (url: string): boolean => {
  if (url.startsWith('file:///')) {
    // Windows path
    if (/^file:\/\/\/[a-zA-Z]:/.test(url)) {
      // eslint-disable-next-line
      return /^file:\/\/\/[a-zA-Z]:(\/|\\)([^\/\\:*?"<>|]+(\/|\\)?)*$/.test(url);
    }

    // Unix path
    return /^file:\/\/\/(\/)?([a-zA-Z0-9._-]+)(\/[a-zA-Z0-9._-]+)*\/?$/.test(url);
  }

  if (/^www\./i.test(url)) {
    return isValidUrl(`https://${url}`);
  }

  const PROTOCOL = '(https?:\\/\\/|ftp:\\/\\/)';
  const DOMAIN_NAME = '(([a-z0-9]([a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9]([a-z0-9-]*[a-z0-9])?)';
  const LOCALHOST = 'localhost';
  const IPV4 = '(\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}\\.\\d{1,3})';
  const IPV6 = '(\\[?[0-9a-f]{0,4}:([0-9a-f]{0,4}:){2,7}([0-9a-f]{0,4})?\\]?)';
  const HOST = `(${DOMAIN_NAME}|${LOCALHOST}|${IPV4}|${IPV6})`;
  const PORT = '(:\\d+)?';
  const PATH = '((\\/[-a-z0-9\\/_.,~%+@&:!=]*)*)';
  const QUERY = '(\\?[;&a-z0-9\\%.\\/_,~%@=\\-\\+]*)?';
  const FRAGMENT = '(#[-a-z0-9_]*)?';

  const webPattern = new RegExp(`^${PROTOCOL}${HOST}${PORT}${PATH}${QUERY}${FRAGMENT}$`, 'i');

  return webPattern.test(url);
};
